<template>
  <div id="app">
    <app-header></app-header>
    <main v-if="!getAdmin" class="main1 d-flex justify-content-center">
      <app-login></app-login>
    </main>
    <main v-else class="main2 d-flex flex-wrap justify-content-around p-2">
      <app-menu class="w-100 w-md-30 w-lg-20"></app-menu>
      <app-crud-card class="mt-3 mt-lg-0 w-100 w-md-65 w-lg-75"></app-crud-card>
    </main>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from './components/shared/Header'
import Login from './components/Login'
import Menu from './components/shared/Menu'
import Footer from './components/shared/Footer'
import CrudCard from './components/shared/CrudCard'
import {mapActions, mapGetters} from "vuex";

export default {
  mounted() {},
  created() {
    if(sessionStorage.selectedComponent) this.setComponent(sessionStorage.selectedComponent);
    if(sessionStorage.selectedOperation) this.setOperation(sessionStorage.selectedOperation);
    this.logout();
  },
  data () {
    return {}
  },
  methods: {
    ...mapActions([
      'setOperation',
      'setComponent',
      'autoLogin',
      'logout'
    ])
  },
  computed: {
    ...mapGetters([
      'getAdmin',
    ])
  },
  components: {
    AppHeader: Header,
    AppMenu: Menu,
    AppFooter: Footer,
    AppCrudCard: CrudCard,
    AppLogin: Login
  }
}
</script>

<style lang="scss">
:root {
  --white-color: rgba(255, 255, 255, 1);
  --white-light-color: rgba(255, 255, 255, .5);
  --black-color: rgba(0, 0, 0, 1);
  --black-light-color: rgba(0, 0, 0, .5);
  --light-color: rgba(139, 245, 255, 1);
  --light-light-color: rgba(139, 245, 255, .5);
  --primary-color: rgba(79, 194, 247, 1);
  --primary-light-color: rgba(79, 194, 247, .5);
  --dark-color: rgba(0, 146, 196, 1);
  --dark-light-color: rgba(0, 146, 196, .5);
}
main{
  margin-top: 20%;
  position: relative;
  overflow: auto;
}
main.main1{
  height: 45vh;
}
main.main2{
  height: 70vh;
}
.cursor-pointer-disabled{
  cursor: not-allowed;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Browse';
}
.custom-file-input:lang(fr) ~ .custom-file-label::after {
  content: 'Parcourir';
}
</style>



// WEBPACK FOOTER //
// src/App.vue